// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__36Zzo","colMin":"styles_colMin__3TOXk","colCheckbox":"styles_colCheckbox__2mOvN"};